import { ConferencePossibleStayPeriod, ConferencePossibleStayPeriodKey } from './conference-stay-period.model';
import { Excursion } from './excursion.model';

export enum ChairmanExtensionConfigurationKeys {
  stayPeriods = 'stayPeriods',
  excursions = 'excursions',
  excursionsBudget = 'excursionsBudget',
}

export class ChairmanExtensionConfiguration {
  [ChairmanExtensionConfigurationKeys.stayPeriods]?: ConferencePossibleStayPeriod[] = [];
  [ChairmanExtensionConfigurationKeys.excursions]?: Excursion[] = [];
  [ChairmanExtensionConfigurationKeys.excursionsBudget]?: number = null;
}
